import { createFileRoute } from "@tanstack/react-router";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";
import { loadBlogPost, blogPostHead } from "@/lib/blogPostRoute";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => loadBlogPost("en", params.slug),
  head: ({ loaderData }) => blogPostHead("en", loaderData?.post),
  component: BlogPostRoute,
  notFoundComponent: NotFound,
  errorComponent: NotFound,
});

function BlogPostRoute() {
  const { post } = Route.useLoaderData();
  return <BlogPost initialRow={post} />;
}
